import { IUserObjectStore } from '../index'

export default function(state: IUserObjectStore): IUserObjectStore {
  return {
    ...state,
    profileRequest: {
      ...state.profileRequest,
      isLoading: false,
    },
    userObject: {
      ...state.userObject,
      profile: {
        ...state.userObject.profile,
        logoUrl: '',
      },
    },
  }
}
